var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flag',{staticStyle:{"height":"20px","width":"20px","border-radius":"50%","margin-right":"5px"},attrs:{"iso":_vm.getFlag}})}
var staticRenderFns = []

export { render, staticRenderFns }